import { render, staticRenderFns } from "./ModalAlert.vue?vue&type=template&id=d56467f6&scoped=true&"
import script from "./ModalAlert.vue?vue&type=script&lang=ts&"
export * from "./ModalAlert.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAlert.vue?vue&type=style&index=0&id=d56467f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56467f6",
  null
  
)

export default component.exports